import { Measure as TBMeasure } from 'services/model/model.service';
import { ChartConfig } from './ChartConfig';
import { ChartDataArray } from './ChartDataArray';

export class BarChartConfig extends ChartConfig {
  rotateXLabels?: boolean;

  tickPadding = 20;

  breakdownData?: ChartDataArray[];

  breakdownMode?: string;

  additionalAxis?: boolean;

  secondaryAsLine?: boolean;

  limitXAxis?: boolean;

  showTooltips = true;

  static forTBMeasure(measure: TBMeasure): BarChartConfig {
    const barChartConfig = new BarChartConfig();
    barChartConfig.value = {
      code: measure.code,
      label: measure.metric.name,
      unit: measure.metric.unit,
      interpretation: measure.metric.interpretation,
    };
    barChartConfig.legendConfig = {
      hide: false,
    };

    return barChartConfig;
  }
}
